import React from 'react';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import Header from './Header';
import Sidebar from './Sidebar';
import { PATHS } from '../../enums/PATHS';
import styles from './Layout.module.scss';
import { useAppSelector } from '../../store/hooks';

type TLayout = {
  children: React.ReactNode;
};

const Layout: React.FC<TLayout> = ({ children }) => {
  const location = useLocation();

  const path = Object.values(PATHS).find((e) => e.path === location.pathname);

  const isPadding = path && path.breadcrumbs;
  const isVideoPage = location.pathname === PATHS.TIMELINE.path || location.pathname === PATHS.COMPOSER_PAGE.path;
  const { isSidebarHidden, showSidebar } = useAppSelector((state) => state.sharedStore);

  return (
    <div className={styles.layout}>
      <Header />
      <div className={styles.mainView}>
        <div>
          <Sidebar currentPath={path} />
        </div>
        <div
          className={cx(!showSidebar ? styles.fullwidth : styles.contentView, {
            [styles.contentViewOffset]: showSidebar && !isVideoPage,
            [styles.contentViewPadding]: isPadding,
            [styles.contentWithoutSidebar]: !path?.sidebar,
            [styles.videoPageView]: isVideoPage,
          })}
        >
          <TransitionGroup component={null}>
            <CSSTransition key={location.pathname} classNames="fade" timeout={400} exit={false}>
              <>{children}</>
            </CSSTransition>
          </TransitionGroup>
        </div>
      </div>
    </div>
  );
};

export default Layout;
